import Icons from "../../assets/icon";
import { IoMdClose } from "react-icons/io";
import { GoCheck } from "react-icons/go";
import { SmAnimatespin, Animatespin } from "../../components/index";
import Functions from "./index.function";
const EmpApplicantslistCom = ({
  title,
  data,
  handleStartChat,
  handleSevedJob,
  handleJobStatusUpdate,
  handleJobStatusSavedUpdate,
  loadingJobStatusSaved,
  requestTitle,
  isLoading,
  savedJobs,
  loadingJobStatusapi,
  handleJobStatusRejectedUpdate,
  loadingJobStatusRejected,
  loading,
  handleRequestJob,
  setValueJobslisting,
  setShowPopup,
  setFilterPopup,
}) => {
  const { colCount, gridStyle, userData } = Functions(title);
  return (
    <div className="">
      {isLoading ? (
        <Animatespin />
      ) : (
        <>
          {data?.length > 0 ? (
            <div className="w-full overflow-x-auto custom-scrollbar">
              <div
                className={`grid grid-cols-${colCount} min-w-[800px] sm:min-w-[1000px] lg:min-w-[1000px] text-secondary bg-[#1A1A1A] px-5 py-3 xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular`}
                style={gridStyle}
              >
                {title.map((value, index) => (
                  <div
                    key={index}
                    className={`flex items-center xs:gap-x-2 sm:gap-x-2.5 ${
                      index === title.length - 1 ? "justify-center" : ""
                    }`}
                  >
                    {value}
                    {/* <img
                      src={Icons.tableTitleIcon}
                      alt="chat"
                      className={`xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-5 xl:h-5 ${
                        index === title.length - 1 ? "hidden" : "block"
                      }`}
                    /> */}
                  </div>
                ))}
              </div>
              {data?.map((value, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-${colCount} min-w-[800px] sm:min-w-[1000px] lg:min-w-[1000px] text-secondary cursor-pointer rounded-lg my-4 px-5 py-4 gap-3 items-center ${
                    index % 2 === 0 ? "bg-[#2A2A2A]" : "bg-transparent"
                  }`}
                  onClick={() => {
                    setValueJobslisting(value);
                    setShowPopup(true);
                    setFilterPopup(false);
                  }}
                  style={gridStyle}
                >
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.talent?.stage_name}
                  </div>
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.talent?.real_name}
                  </div>
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.talent?.age}
                  </div>
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.talent?.gender?.gender}
                  </div>
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.talent?.ethnicity?.name}
                  </div>
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.talent?.country?.country}
                  </div>
                  <div className=" xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular flex items-center justify-center gap-x-1">
                    <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular flex items-center justify-center">
                      <div
                        className="bg-[#3E3E3E] xs:w-5 xs:h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8 flex justify-center items-center rounded-full cursor-pointer"
                        onClick={(event) => {
                          event.stopPropagation();
                          handleStartChat(
                            userData?.employer?.user_id,
                            value?.talent?.user_id
                          );
                        }}
                      >
                        {loading === value?.talent?.id ? (
                          <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary w-6 h-6"></div>
                        ) : (
                          <img
                            src={Icons.chatIcon}
                            alt="chat"
                            className="xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-[18px] xl:h-[18px]"
                          />
                        )}
                      </div>
                    </div>
                    {requestTitle === "approved requests" ? (
                      ""
                    ) : (
                      <>
                        {requestTitle === "saved requests" ? (
                          ""
                        ) : (
                          <div
                            className="flex justify-center items-center rounded-full xs:w-5 bg-[#3E3E3E] xs:h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleJobStatusSavedUpdate(
                                value?.talent?.id,
                                "Saved"
                              );
                            }}
                          >
                            {loadingJobStatusSaved ? (
                              <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary w-6 h-6"></div>
                            ) : savedJobs.includes(
                                String(value?.talent?.id)
                              ) ? (
                              <img
                                src={Icons.dasSavedIcon}
                                className="xs:w-3.5 xs:h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5"
                                alt="MdOutlineStar"
                              />
                            ) : (
                              <img
                                src={Icons.dasSaveIcon}
                                className="xs:w-2.5 xs:h-2.5 sm:w-3 sm:h-3 lg:w-4 lg:h-4"
                                alt="MdOutlineStarBorder"
                              />
                            )}
                          </div>
                        )}
                        <div
                          className="text-rejected bg-[#3E3E3E] xs:p-1.5 sm:p-1.5 lg:p-2 rounded-full cursor-pointer"
                          onClick={(event) => {
                            event.stopPropagation();
                            handleJobStatusRejectedUpdate(
                              value?.talent?.id,
                              "Rejected"
                            );
                          }}
                        >
                          <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base">
                            {loadingJobStatusRejected ? (
                              <SmAnimatespin />
                            ) : (
                              <IoMdClose />
                            )}
                          </p>
                        </div>
                        <div
                          className="text-accepted bg-[#3E3E3E] xs:p-1.5 sm:p-1.5 lg:p-2 rounded-full cursor-pointer"
                          onClick={(event) => {
                            event.stopPropagation();
                            handleJobStatusUpdate(
                              value?.talent?.id,
                              "Accepted"
                            );
                          }}
                        >
                          <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base">
                            {loadingJobStatusapi ? (
                              <SmAnimatespin />
                            ) : (
                              <GoCheck />
                            )}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-secondary capitalize text-center">
              No {requestTitle} request available.
            </p>
          )}
        </>
      )}
    </div>
  );
};
export default EmpApplicantslistCom;
